import { PracticalExamShareTranslation } from '@/assets/locales/views/practicalExamShare/practicalExamShare.translation.en.ts';

export const practicalExamShareTranslation: PracticalExamShareTranslation = {
  invalidOrExpired: 'Ten link jest nieprawidłowy lub wygasł.',
  noAttachments: 'Brak załączników',
  pdfPreviewError: 'Nie udało się załadować podglądu PDF',
  pdfPreviewLoading: 'Ładowanie podglądu…',
  pdfPreviewPager: 'Strona {{page}} / {{total}}',
  questions: 'Pytania ({{count}})',
  reports: 'Raporty ({{count}})',
  title: 'Podejście do egzaminu praktycznego {{number}}',
};
